import React from 'react';
import { cn } from '@/lib/utils';

/**
 * Spinner sizes mapping to Tailwind dimension classes.
 */
const SIZES = {
  xs: 'h-3 w-3',
  sm: 'h-4 w-4',
  md: 'h-8 w-8',
  lg: 'h-12 w-12',
  xl: 'h-16 w-16',
};

/**
 * Reusable loading spinner component.
 *
 * @param {'xs'|'sm'|'md'|'lg'|'xl'} size - Spinner size preset
 * @param {string} color - Tailwind border color class (e.g. "border-blue-600")
 * @param {string} className - Additional CSS classes
 */
export const Spinner = ({ size = 'md', color = 'border-blue-600', className }) => (
  <div
    className={cn(
      'animate-spin rounded-full border-b-2',
      color,
      SIZES[size] || SIZES.md,
      className
    )}
  />
);

/**
 * Full loading state with spinner and optional message.
 * Use for page-level or section-level loading states.
 *
 * @param {string} message - Loading message text
 * @param {'sm'|'md'|'lg'|'xl'} size - Spinner size
 * @param {string} color - Tailwind border color class
 * @param {string} className - Additional wrapper CSS classes
 */
export const LoadingState = ({
  message = 'Loading...',
  size = 'lg',
  color = 'border-blue-600',
  className,
}) => (
  <div className={cn('flex items-center justify-center p-8', className)}>
    <div className="text-center">
      <Spinner size={size} color={color} className="mx-auto mb-4" />
      <p className="text-gray-600 dark:text-gray-400">{message}</p>
    </div>
  </div>
);

export default Spinner;
